/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Initial_Role_NameInputs */

const en_admin_settings_fields_initial_role_name = /** @type {(inputs: Admin_Settings_Fields_Initial_Role_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default role name`)
};

/**
* | output |
* | --- |
* | "Default role name" |
*
* @param {Admin_Settings_Fields_Initial_Role_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_initial_role_name = /** @type {((inputs?: Admin_Settings_Fields_Initial_Role_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Initial_Role_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_initial_role_name(inputs)
});
export { admin_settings_fields_initial_role_name as "admin.settings.fields.initial_role_name" }